// vehicle attributes
import * as vehicleAttributes from '@drivesally/sally-fn/lib/vehicle/attributes';

export default () =>
  Object.values(vehicleAttributes)
    .filter(
      (attribute) =>
        !['insurance_policy_number', 'eld_device_serial'].includes(
          attribute.attribute
        )
    )
    .reduce(
      (combined, attribute) =>
        !!combined.find(
          (existingAttribute) => existingAttribute.value === attribute.attribute
        )
          ? combined
          : [
              ...combined,
              {
                value: attribute.attribute,
                label: attribute.label.default,
              },
            ],
      []
    );
